import script from "./NotFoundPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts&setup=true"

import "./NotFoundPage.vue?vue&type=style&index=0&id=05fb1f1d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fb1f1d"]])

export default __exports__